(function ($) {
    $(document).ready(function () {
        $(document).on('click', '.d_option', function () {
            $('.d_option').removeClass('active');
            $(this).toggleClass('active');
        });

        $(document).on('mouseleave', '.drop_options', function () {
            $('.d_option').removeClass('active');
        });

        $(document).on('click', '.click_img', function () {
            const img = $(this).attr('src');
            $('.lightbox_img').attr('src', img);
            $('.lightbox').addClass('active');
        });

        $(document).on('click', '.lightbox_cerrar,.lightbox_overlay', function () {
            $('.lightbox').removeClass('active');
            $('.lightbox_img').attr('src', '');
        });

        // MOSTRSR
        $(document).on('click', '.tfiltros_select', function () {
            $('.filtrosCtn').addClass('active');
        });

        $(document).on('click', '.filtro_tipo', function () {
            var data = $(this).attr('data-click');

            $('.filtro_tipo').removeClass('current');
            $(this).addClass('current');


            $('.filtro_submenu').removeClass('current');
            $('.filtro_submenu[data-type=' + data + ']').addClass('current');

            //mobile

            $('.filtros2').addClass('active');
            $('.filtros_botones').addClass('active');

        });

        $(document).on('click', '.cerrar_submenu', function () {
            $('.filtros2, .filtros_botones').removeClass('active');
            $('.filtro_tipo, .filtro_submenu').removeClass('current');
        });

        $(document).on('click', '.collapse', function () {
            $('.menu').toggleClass('collap');
            $('body').toggleClass('collap2');

            // $('.submenu').slideUp();
            // $('.data_acordeon').removeClass('active');
        });


        $(document).on('click', '.open_responsive,.menu_responsive_overlay', function () {
            $('.menu,.menu_responsive_overlay').toggleClass('active');
        });
        $('.menu_responsive_overlay').click(function () {
            $(this).removeClass('active');
        });


        setTimeout(() => {
            $('.hhead_user').clone().appendTo('.user_responsive');
        }, 1000)


        $(document).on('click', '.data_acordeon', function () {
            $('.submenu:visible').not(this).slideToggle();
            $('.data_acordeon').not(this).removeClass('active');
            if ($(this).siblings('.submenu').is(':hidden')) {
                $(this).siblings('.submenu').slideToggle();
            }
            $(this).toggleClass('active');
        });


        $(document).on('click', '.hhead_user', function () {
            $(this).find('p').slideToggle();
        });
        $(document).on('click', '.wrapper', function () {
            $('.hhead_user').find('p').slideUp();
        });


    });
})(jQuery);



// WEBPACK FOOTER //
// ./src/assets/scripts/custom.js